import Timeline from "./Timeline.js";

/**
 * A version of {@link EPSON.Timeline} made for the video element.
 */
export default class TimelineVideo extends Timeline {

    /**
     * @inheritDoc
     */
    setup() {

        const {
            element,
        } = this;

        element.addEventListener("play", () => this.startTicking());
        element.addEventListener("pause", () => this.stopTicking());
        // element.addEventListener("ended", () => this.stopTicking());

    }

    /**
     * Returns the progress percentage.
     *
     * @return {Number}
     *         Progress percentage.
     */
    getPercent() {
        return (this.element.currentTime / this.element.duration) * 100;
    }

}
